import { css, keyframes } from 'emotion';

const fadeIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(12px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

const shimmer = keyframes`
  0% {
    background-position: -200% 0;
  }
  100% {
    background-position: 200% 0;
  }
`;

const float = keyframes`
  0%, 100% {
    transform: translate(0, 0) scale(1);
  }
  33% {
    transform: translate(30px, -20px) scale(1.05);
  }
  66% {
    transform: translate(-20px, 15px) scale(0.95);
  }
`;

export const authBackground = css`
  position: relative;
  min-height: 100vh;
  background: #0a0a1a;
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    top: -40%;
    left: -20%;
    width: 80%;
    height: 80%;
    background: radial-gradient(ellipse, rgba(56, 78, 183, 0.15) 0%, transparent 70%);
    animation: ${float} 20s ease-in-out infinite;
    pointer-events: none;
  }

  &::after {
    content: '';
    position: absolute;
    bottom: -30%;
    right: -10%;
    width: 60%;
    height: 70%;
    background: radial-gradient(ellipse, rgba(99, 54, 168, 0.12) 0%, transparent 70%);
    animation: ${float} 25s ease-in-out infinite reverse;
    pointer-events: none;
  }
`;

export const noiseOverlay = css`
  position: fixed;
  inset: 0;
  opacity: 0.03;
  pointer-events: none;
  z-index: 0;
  background-image: url("data:image/svg+xml,%3Csvg viewBox='0 0 256 256' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='noise'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='4' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23noise)'/%3E%3C/svg%3E");
  background-repeat: repeat;
  background-size: 256px 256px;
`;

export const login = css`
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  padding: 2rem;
  animation: ${fadeIn} 0.6s ease-out;
`;

export const logoContainer = css`
  margin-bottom: 2.5rem;
  animation: ${fadeIn} 0.6s ease-out;
  animation-delay: 0.1s;
  animation-fill-mode: both;
`;

export const formCard = css`
  width: 480px;
  min-height: 420px;
  padding: 2.5rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  background: rgba(255, 255, 255, 0.03);
  backdrop-filter: blur(24px);
  -webkit-backdrop-filter: blur(24px);
  border: 1px solid rgba(255, 255, 255, 0.06);
  border-radius: 20px;
  box-shadow:
    0 0 0 1px rgba(255, 255, 255, 0.03),
    0 8px 40px rgba(0, 0, 0, 0.3),
    0 2px 8px rgba(0, 0, 0, 0.2),
    inset 0 1px 0 rgba(255, 255, 255, 0.04);
  animation: ${fadeIn} 0.6s ease-out;
  animation-delay: 0.2s;
  animation-fill-mode: both;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 1px;
    background: linear-gradient(
      90deg,
      transparent,
      rgba(255, 255, 255, 0.08),
      transparent
    );
  }
`;

export const shimmerLine = css`
  width: 100%;
  max-width: 480px;
  height: 1px;
  margin-top: 1.5rem;
  background: linear-gradient(
    90deg,
    transparent,
    rgba(255, 255, 255, 0.06),
    rgba(99, 102, 241, 0.15),
    rgba(255, 255, 255, 0.06),
    transparent
  );
  background-size: 200% 100%;
  animation: ${shimmer} 3s ease-in-out infinite;
`;

export const previousStep = css`
  width: 100%;
  max-width: 480px;
  margin-bottom: 0.75rem;
  animation: ${fadeIn} 0.5s ease-out;
  animation-delay: 0.15s;
  animation-fill-mode: both;
`;

export const gridLine = css`
  position: absolute;
  background: rgba(255, 255, 255, 0.02);
  pointer-events: none;
  z-index: 0;
`;
